import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  hideConfirmSubmitModal,
  confirmSubmit,
} from 'actions/ingredients/recipes';
import styles from './ConfirmSubmitModal.css';

class ConfirmSubmitModal extends React.Component {
  render() {
    const { showConfirmSubmitModal } = this.props;
    return (
      <Modal
        show={showConfirmSubmitModal}
        dialogClassName={styles['modal-dialog']}
      >
        <Modal.Header bsClass={`modal-header ${styles['modal-header']}`}>
          Information
        </Modal.Header>
        <Modal.Body>
          Do you want to save the recipes? You will not be able to modify after
          changes are made.
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={this._onHide}
            className="btn btn-default"
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this._onClickCreate}
          >
            Create
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onHide = () => {
    const { dispatch } = this.props;
    dispatch(hideConfirmSubmitModal());
  };

  _onClickCreate = () => {
    const {
      recipesForm,
      dispatch,
      search: { date },
    } = this.props;
    const namespace = this._namespace();
    dispatch(confirmSubmit(recipesForm, namespace, date));
  };

  _namespace = () => {
    const { search } = this.props;
    if (search) {
      return search.namespace;
    }
    return '';
  };
}

function mapStateToProps(state) {
  const { showConfirmSubmitModal } = state.ingredients.recipes;
  return {
    recipesForm: getFormValues('recipes')(state),
    showConfirmSubmitModal,
    search: getFormValues('search')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmSubmitModal);
